module.exports = __webpack_public_path__ + "static/media/other-benefits.2bcac245.svg";